<template>
  <fieldset id="map-bottom-popup-info">
    <legend class="info-header font-h2">详情</legend>
    <div class="info-content">
      <div class="info-base">
        <edit-input-vue
          v-for="(info, index) in baseList"
          v-model="info.value"
          :key="index"
          :label="info.label"
          :readonly="info.readonly"
          :options="info.options"
        >
        </edit-input-vue>
      </div>
      <div class="info-plan" v-if="false">
        <edit-input-vue
          v-for="(info, index) in planList"
          v-model="info.value"
          :key="index"
          :label="info.label"
          :readonly="info.readonly"
        >
        </edit-input-vue>
      </div>
      <div class="info-plan" v-if="!authToken"></div>
    </div>
  </fieldset>
</template>

<script>
import { mapGetters } from 'vuex';
import editInputVue from '../layout/edit-input';
export default {
  components: {
    editInputVue
  },
  props: {
    mapRelicDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('login', ['authToken']),
    baseList() {
      return [
        {
          label: '建筑类别',
          readonly: true,
          value: this.mapRelicDetail.relicEditPageInfoDTO.relicTypeEnum || ''
        },
        {
          label: '建筑年代',
          readonly: true,
          value: this.mapRelicDetail.relicEditPageInfoDTO.relicAge || ''
        },
        {
          label: '建筑地址',
          readonly: true,
          value: this.mapRelicDetail.relicEditPageInfoDTO.relicAddress || '',
          options: {
            type: 'textarea'
          }
        },
        {
          label: '建筑简介',
          readonly: true,
          value:
            this.mapRelicDetail.relicEditPageInfoDTO.relicIntroduction ||
            '暂无简介',
          options: {
            type: 'textarea'
          }
        }
      ];
    },
    planList() {
      return [
        {
          label: '保护范围',
          readonly: true,
          value: `${this.mapRelicDetail.relicEditPageInfoDTO.protectArea ||
            '----'}㎡`
        },
        {
          label: '建控地带',
          readonly: true,
          value: `${this.mapRelicDetail.relicEditPageInfoDTO.controlArea ||
            '----'}㎡`
        }
      ];
    }
  },
  data() {
    return {
      // baseList: [
      //   {
      //     label: '建筑类别',
      //     readonly: true,
      //     value: this.mapRelicDetail.relicEditPageInfoDTO.relicTypeEnum || ''
      //   },
      //   {
      //     label: '建筑年代',
      //     readonly: true,
      //     value: this.mapRelicDetail.relicEditPageInfoDTO.relicAge || ''
      //   },
      //   {
      //     label: '建筑编号',
      //     readonly: true,
      //     value: this.mapRelicDetail.relicEditPageInfoDTO.relicFromUserId || ''
      //   },
      //   {
      //     label: '建筑地址',
      //     readonly: true,
      //     value: this.mapRelicDetail.relicEditPageInfoDTO.relicAddress || '',
      //     options: {
      //       type: 'textarea'
      //     }
      //   }
      // ],
      // planList: [
      //   {
      //     label: '建筑面积',
      //     readonly: true,
      //     value: ``
      //   },
      //   {
      //     label: '保护范围',
      //     readonly: true,
      //     value: `${this.mapRelicDetail.relicEditPageInfoDTO.protectArea ||
      //       ''}㎡`
      //   },
      //   {
      //     label: '建控地带',
      //     readonly: true,
      //     value: `${this.mapRelicDetail.relicEditPageInfoDTO.controlArea ||
      //       ''}㎡`
      //   },
      //   {
      //     label: '建筑简介',
      //     readonly: true,
      //     value: '',
      //     options: {
      //       type: 'textarea'
      //     }
      //   }
      // ]
    };
  }
};
</script>

<style lang="scss">
#map-bottom-popup-info {
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid $color-border-light;
  .info-content {
    display: flex;
    justify-content: space-between;
  }
  .edit-input {
    &__content {
      width: 500px;
    }
  }
}
@media screen and(max-width:750px) {
  .edit-input {
    flex-direction: column;
    &__content {
      margin-left: 5px;
      width: calc(100vw - 50px) !important;
    }
  }
}
</style>
